export default "__VITE_ASSET__e3ee3932__"